import React from "react";
import * as S from "./styles";

const Dropdown = ({ options, ...props }) => {
  return (
    <S.Container>
      <S.Dropdown {...props} options={options} classNamePrefix="select" />
    </S.Container>
  );
};

export default Dropdown;
